import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

const AddCommissionCompanyModal = ({ show, handleClose, handleSave }) => {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!name.trim()) {
            toast.error('Company name is required');
            return;
        }

        if (name.trim().length > 30) {
            toast.error('Company name must be 30 characters or less');
            return;
        }

        setLoading(true);
        try {
            const response = await api.post('/commission-companies', { name: name.trim() });
            if (response.data.status) {
                toast.success('Commission company added successfully!');
                setName('');
                handleSave();
            } else {
                toast.error(response.data.message || 'Failed to add commission company');
            }
        } catch (error) {
            console.error('Error adding commission company:', error);
            toast.error(error.response?.data?.message || 'Error adding commission company');
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setName('');
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Commission Company</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="name" className="mb-3">
                        <Form.Label>
                            Company Name <span className="text-danger">*</span>
                            <span className="text-muted fw-normal"> (Max 30 characters)</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter company name"
                            required
                            maxLength={30}
                        />
                        <Form.Text className="text-muted">
                            {name.length}/30 characters
                        </Form.Text>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? <><Spinner animation="border" size="sm" className="me-2" /> Adding...</> : 'Add Company'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddCommissionCompanyModal;
